var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasAuthed)?_c('div',{staticClass:"togglecon showsmonly"},[_c('div',{staticClass:"toggleout",on:{"click":_vm.onToggleSidebar}},[_c('Icon',{staticClass:"togglesvg",attrs:{"src":"toggle"}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }